/**
 * モーダル用の閉じるボタン
 * @param props
 * @returns
 */
export default function CloseButton({ onClose }) {
  return (
    <button className="close" onClick={onClose}>
      ×
    </button>
  );
}
